import React from 'react';
import styled from 'styled-components';

import useTranslation from 'src/hooks/use-translation';
import { DutchiePayHeader, DutchiePayTextBody } from 'src/payments/components';

import HelpCenter from 'src/assets/help-center';
import { OrderHeaderCard } from '../base/order-header';

export function ErrorLoadingInvoiceHeader(): JSX.Element {
  const { t } = useTranslation();

  return (
    <OrderHeaderCard
      icon={<HelpCenter />}
      body={
        <>
          <DutchiePayHeader>
            {t('dutchie.in-store.order-header.invoice-load-failed', 'Unable to load invoice')}
          </DutchiePayHeader>

          <DutchiePayTextBodyWithoutMargin>
            {t(
              'dutchie.in-store.order-header.different-method',
              'Please use a different method of payment or ask your retailer to try again.'
            )}
          </DutchiePayTextBodyWithoutMargin>
        </>
      }
    />
  );
}

const DutchiePayTextBodyWithoutMargin = styled(DutchiePayTextBody)`
  margin: 0;
`;
